
// import { pp, pp_user, app_state, notify } from '@helpers'

// import {  } from "@stores";

export const useRecipientStore = {

    state: ()/* : State */ => ({

        form: {},

    }),

    getters: {

        // getXXX(){
        //     return (status) => {
        //         return 
        //     }
        // },
    },

    actions: {

        setRecipient(recipient){
            if( ! recipient){ recipient = {} } // for Create


            recipient = {
                ...recipient,

                id:             recipient.id             ?? null,
                label:          recipient.label          ?? '',
                sap:            recipient.sap            ?? null,
                business_id:    recipient.business_id    ?? null,
                emails:         recipient.emails         ?? [],
                contact:        recipient.contact        ?? '',
                address:        recipient.address        ?? '',
                description:    recipient.description    ?? '',
                phone:          recipient.phone          ?? '',
                latitude:       recipient.latitude       ?? null,
                longitude:      recipient.longitude      ?? null,
            }

            return recipient
        },


        // for Edit and Create
        initForm(recipient){

            recipient = this.setRecipient(recipient)

            this.form = proto.$inertia.form(recipient)

            // log('in stores/colis @initForm()',this.form)
        },

        // for Edit (in Index) and Create
        submit(){

            var router = this.form.id ? route('recipient.update', this.form.id) : route('recipient.store')

            // const formDatas = this.form.data()

            this.form
                // .transform(data => ({
                //     ...data,
                // }))
                [this.form.id ? 'put' : 'post'](router, {
                    preserveScroll: true,
                    // onSuccess: () => {
                    //     this.form.reset();
                    // },
                });
        },

    }
}
